<template>
  <div>
  
  
  
   <!-- start company info header -->
  
  <div style="margin-bottom: 90px;background-color: #fff;color: #000;padding: 15px 30px;text-align:center;cursor:pointer;
  				" @click="goToEntity()">
 	<div style="">
 		<div style="padding-bottom:10px;">
   		<div style="font-size: 29px; text-transform: uppercase;font-family:georgia;"> {{coy.entity_name}}</div>
   		<div> <span>UEN: &nbsp;   </span> {{coy.uen}}</div>
   		</div>
    </div>
  </div>
  
  <!-- end company info header -->
  
  
   <card>
        <h5 style="font-weight:bold;">Upload New Mail</h5>

                
                
            
             <div class="col-sm-7">    
                 <fg-input type="text"
                  name="mail name"
				  label="Mail Name"                  
                  v-model="new_mail.document_name">
       			 </fg-input>
            </div>
        
        	
        	
        	
        	<div class="col-sm-7">    
                 <fg-input type="text"
                  name="remarks"
				  label="Remarks (optional)"                  
                  v-model="new_mail.notes">
       			 </fg-input>
            </div>
        	
        	<div style="margin-top:30px;"><input type="file" id="file" ref="new_file" class="btn btn-default" /></div>
        	
        	<p-button    @click.prevent="uploadNewMail()" type="info" style="width:100%;">
   				 <i slot="label" class="nc-icon nc-cloud-upload-94"></i>
           				Upload Mail
   			 </p-button> 
    </card>
        
        
       
       
       <div style="margin-top:90px;">
       <h5 style="font-weight:bold;"> Digital Mailbox</h5>
  		</div>
		
        <div class="card" style="margin-bottom:50px">
          <div class="card-body table-responsive table-full-width">
            <el-table :data="mails">
                <el-table-column label="Title" property="document_name" ></el-table-column>
                <el-table-column label="Uploaded" property="uploaded_at"></el-table-column>
                 <el-table-column label="Remarks" property="notes"></el-table-column>
    
                    <el-table-column label="" width="90">
            		<template slot-scope="scope">
            			 <p-button type="success" size="sm" icon @click="viewMail(scope.row.id)">
                 			 <i class="fa fa-edit"></i>
                		</p-button>
					</template>
               </el-table-column>
                 
            </el-table>

          </div>
        </div>
        
        
        
  
    </div>
</template>
<script>
  import {DatePicker, TimeSelect, Slider, Tag, Input, Button, Select, Option} from 'element-ui'
  import {Collapse, CollapseItem, Tabs, TabPane, Card} from 'src/components/UIComponents'
  import ApiService from 'src/services/api.service'
  import swal from 'sweetalert2'
  
  
  
  export default {
    components: {
      [DatePicker.name]: DatePicker,
      [TimeSelect.name]: TimeSelect,
      [Slider.name]: Slider,
      [Tag.name]: Tag,
      [Input.name]: Input,
      [Button.name]: Button,
      [Option.name]: Option,
      [Select.name]: Select,
      TabPane,
      Tabs,
      CollapseItem,
      Collapse,
      Card
    },
    
     mounted() {

      	this.loadMailbox();
    },
    
     
    data () {
      return {
        coy:[],
        mails:[],
    	eid: this.$route.params.eid,
		 new_mail: {
          document_name: '',
          notes:'',
        },
        modelValidations: {
          title: {
          },
          description: {
          },
          amount: {
            required: true,
            decimal:true,
          },
          due_date: {
          	required: true,
          },
         
          
        },
      }
    },
    methods:{
      goToEntity(){
	  	 this.$router.push( '/view-entity/'+this.coy.id);
	    },
	    loadMailbox(){
	    	let uri = this.$base_url+'/api/v1/digital_mail/get_mails/'+ this.$route.params.eid;
			 ApiService.get(uri).then(response => {
				this.coy = response.data.entity;
				this.mails = response.data.mails;
			})
	    },
	    viewMail(mid){
	    	this.$router.push( '/view-mail/'+mid);
	    
	    },
	   uploadNewMail(){
    	 	   if(!this.$refs.new_file.files[0]){
    	 	   
    	 	   	return false;
    	 	   }
    	 
    	 
    	 		if( this.new_mail.document_name==""){
    	 			  swal({
						  title: 'Oops',
						  text: 'Please enter a name for this mail.',
						  type: 'error',
						  confirmButtonClass: 'btn btn-success btn-fill',
						  buttonsStyling: false
			 		})
    	 			return false;
    	 		}
    	 
    	 
    	 		swal.showLoading();
      			let uploaded_file = this.$refs.new_file.files[0];
      			let formData = new FormData();
  			    formData.append('file', uploaded_file);
  			    formData.append('mail_document_name', this.new_mail.document_name);
  			    formData.append('mail_notes', this.new_mail.notes);
  			    
  			    const vm = this;
  			    if(this.new_mail.document_name ==""){
  			    	this.new_mail.document_name = '-';
  			    }
  			    
  			     let uri = this.$base_url+'/api/v1/digital_mail/upload_mail/'+ this.$route.params.eid;
				 ApiService.post(uri,formData).then(response => {
						swal({
						  title: 'Uploaded.',
						  text: 'The file has been uploaded.',
						  type: 'success',
						  confirmButtonClass: 'btn btn-success btn-fill',
						  buttonsStyling: false
						}).then(function(){
								swal.close();
								vm.new_mail.document_name = '';
								vm.loadMailbox();
						})//end swal
			
				  })
      	
      	
      	}
      
    },

    
  }
</script>
<style>
  .extended-forms .el-select {
    width: 100%;
  }
  
  .el-date-editor .el-input__inner{
  	padding-left:36px!important;
  }
</style>


